export var ProductType;
(function (ProductType) {
    ProductType["RSVP"] = "Rsvp";
    ProductType["EVENT"] = "Event";
    ProductType["GALLERY"] = "Gallery";
    ProductType["ADDITIONALPAGE"] = "AdditionalPage";
    ProductType["SAVEDATE"] = "SaveDate";
    ProductType["SENDER"] = "Sender";
    ProductType["GKS"] = "GKS";
    ProductType["BINGO"] = "Bingo";
    ProductType["VIDEOGALLERY"] = "VideoGallery";
    ProductType["PHYSICALMATERIAL"] = "PhysicalMaterial";
    ProductType["CALUCLATORS"] = "Calculators";
    ProductType["UNKNOW"] = "Unknow";
})(ProductType || (ProductType = {}));
export var ProductName;
(function (ProductName) {
    ProductName["GOLD"] = "Pakiet Gold";
    ProductName["SILVER"] = "Pakiet Silver";
    ProductName["BASIC"] = "Pakiet Basic";
    ProductName["PLATINIUM"] = "Pakiet Platinium";
    ProductName["DIAMOND"] = "Pakiet Diamond";
    ProductName["SAVEDATE"] = "Save The Date";
    ProductName["QRINSTRUCTION"] = "10 instrukcji z kodem QR";
    ProductName["GUESTTASKS"] = "40 karty zada\u0144 dla go\u015Bci";
    ProductName["QRCARDS"] = "100 wizyt\u00F3wek z kodem QR";
    ProductName["NFCSTICKER"] = "Naklejka Potwierdzenie NFC - 20szt.";
    ProductName["QRPLATE"] = "Tabliczka z kodem QR";
    ProductName["WEDDINGPLANER"] = "Planer \u015Alubny";
    ProductName["NIGHTGAMEGAME"] = "Zabawy na wiecz\u00F3r panie\u0144ski/kawalerski";
})(ProductName || (ProductName = {}));
//# sourceMappingURL=userProducts.js.map